import { PropsWithChildren } from "react";
import React from "react";
import AppHeader from "../components/layout/app-header";
import AppFooter from "../components/layout/app-footer";
import SandboxBar from "../components/layout/sandbox-bar";
import SkipLinks, { MAIN_CONTENT_ID } from "../components/layout/skip-links";
import { Box, Container } from "@mui/material";

interface BaseProps extends PropsWithChildren<any> {
    /** Sem container: a página controla as próprias faixas de largura total (home). */
    fullWidth?: boolean,
}

const BaseComponent: React.FC<BaseProps> = ({ fullWidth = false, children }) => {
    return (
        <React.Fragment>
            <SkipLinks />
            <AppHeader />
            <Box
                component="main"
                id={MAIN_CONTENT_ID}
                tabIndex={-1}
                sx={{
                    minHeight: 'calc(100vh - 400px)',
                    backgroundColor: 'background.default',
                }}
            >
                {fullWidth ? children : (
                    <Container maxWidth="xl" sx={{ pt: { xs: 3, md: 4 }, pb: { xs: 6, md: 9 } }}>
                        {children}
                    </Container>
                )}
            </Box>
            <AppFooter />
            <SandboxBar />
        </React.Fragment>
    );
};

export default BaseComponent;
